import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Modal as AntdModal,
  Select,
  InputNumber,
  Row,
  Col,
  message,
} from "antd";
import { phoneReg } from "@/utils/rules";
import { getPositionList } from "@/api/operation";
import Cycle from "./Cycle";

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 20 },
  },
};

const Modal = (props) => {
  const {
    form,
    current,
    visible,
    onAdd = () => {},
    onCancel = () => {},
    getContainer,
    onEdit = () => {},
    cycleData=[],
    companyList,
  } = props;

  const [positionList, setPositionList] = useState([]);

  const [companyId, setCompanyId] = useState();

  const [list, setList] = useState([]);

  const fetchPositionList = (companyId) => {
    getPositionList({
      companyId,
    }).then((res) => {
      if (res.success) {
        setPositionList(
          res.data.map((item, index) => ({
            label: item.name,
            value: item.pointId,
          }))
        );
      }
    });
  };

  useEffect(() => {
    if (companyId) {
      fetchPositionList(companyId);
    }
  }, [companyId]);

  const isFull = (cycle) =>
    cycle.cycle && cycle.pointPrice >= 0 && cycle.advertisementPrice >= 0;

  const handleConfirm = (values) => {
    const everyCycle = list.every(isFull);
    if (!everyCycle) return message.error("请先将投放周期填写完整!");

    form.validateFields((err, values) => {
      if (!err) {
        onAdd({
          ...values,
          list: list.map((item) => ({ ...item, cycle: Number(item.cycle) })),
        });
      }
    });
  };

  const handleChangeCompany = (companyId) => {
    setCompanyId(companyId);
  };

  const handleChangeCycle = (cycles) => {
    setList([...cycles]);
  };

  return (
    <AntdModal
      destroyOnClose={true}
      title={current?.companyId ? "计费规则设置" : "计费规则设置"}
      visible={visible}
      onOk={handleConfirm}
      onCancel={onCancel}
      width={800}
      wrapClassName={"modal"}
      getContainer={getContainer}
      bodyStyle={{ paddingLeft: 0, paddingRight: 0 }}
    >
      <Form {...formItemLayout}>
        <Form.Item label="运营商名称">
          {form.getFieldDecorator(
            "companyId",
            current.companyId
              ? {
                  initialValue: current.companyId,
                  rules: [{ required: true, message: "请输入运营商名称" }],
                }
              : {
                  rules: [{ required: true, message: "请输入运营商名称" }],
                }
          )(
            <Select
              style={{ width: 324 }}
              placeholder="请选择运营商"
              onChange={handleChangeCompany}
            >
              {companyList.map((equip) => (
                <Select.Option value={equip.value} key={equip.value}>
                  {equip.label}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="投放点位">
          {form.getFieldDecorator(
            "tryPointId",
            current.tryPointId
              ? {
                  initialValue: current.tryPointId,
                  rules: [{ required: true, message: "请选择投放点位" }],
                }
              : {
                  rules: [{ required: true, message: "请选择投放点位" }],
                }
          )(
            <Select style={{ width: 324 }} placeholder="请选择投放点位">
              {positionList.map((equip) => (
                <Select.Option value={equip.value} key={equip.value}>
                  {equip.label}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Cycle onChange={handleChangeCycle} cycleData={cycleData} />
      </Form>
    </AntdModal>
  );
};

export default Form.create()(Modal);
